<template>
    <div v-show="show">
        <div class="group-list-popup">
            <div class="popup-head">
                <div class="head-top">他们正在拼团...</div>
                <div class="head-bottom">仅显示前10人</div>
            </div>
            <div class="popup-body">
                <div class="popup-scroll">
                    <div class="group-popup-detail" v-for="item in groupList">
                        <div class="group-popup-detail-left">
                            <img :src="item.organiserHeadImg" class="detail-img" />
                            <div class="detail-desc">
                                <span class="desc-text">{{item.organiserNickname}}的团 只差<span class="text-num">{{item.remainPersonNum}}</span>人</span>
                                <span class="desc-countdown">仅剩 {{item.remainTimeFormat}}</span>
                            </div>
                        </div>
                        <div class="group-popup-detail-right" @click="joinGroup(item.groupId)">去参团</div>
                    </div>
                </div>
            </div>
            <div class="popup-close" @click="closePopup">
                <img src="https://m.tuniucdn.com/fb2/t1/G5/M00/0B/5E/Cii-tFsGYcuIAqr8AAAD5qeaGFkAAHMEgP__AIAAAP-857.png"
                    class="close-img" />
            </div>
        </div>
        <div class="mask"></div>
    </div>
</template>

<script>

    export default {
        props: {
            show: {
                type: Boolean,
                default: false
            },
            groupList: {
                type: Array,
                default: () => ([])
            }
        },

        data () {
            return {
                scrollTop: 0
            }
        },

        methods: {
            closePopup() {
                this.$emit('update:show', false);
            },
            joinGroup(groupId) {
                let url = `${window.location.origin}/wap-groupon/group/detail/${groupId}`;
                window.location.href = url;
            }
        },

        watch: {
            show (val) {
                if (val) {
                    this.scrollTop = document.scrollingElement.scrollTop;
                    document.body.style.position="fixed";
                    document.body.style.width="100%";
                    document.body.style.top = -this.scrollTop + 'px';
                } else {
                    document.body.removeAttribute('style');
                    document.scrollingElement.scrollTop = this.scrollTop;
                }
            }
        }
    }

</script>

<style lang="scss">
    ::-webkit-scrollbar {
        width: 0;
        height: 0;
        color: transparent;
    }

    .group-list-popup {
        position: fixed;
        top: 40%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 306px;
        background: #FFF;
        border-radius: 18px;
        z-index: 21;

        .popup-head {
            height: 52px;
            color: #FFF;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            background-size: 100% 100%;
            background-image: url(https://m2.tuniucdn.com/fb2/t1/G4/M00/F7/D2/Cii_J1y1fs2ISPTgAAAS-0vdpg4AAFSHQP_55IAABMT909_w640_h0_c0_t0.png);

            .head-top {
                font-family: PingFangSC-Semibold;
                font-size: 15px;
            }

            .head-bottom {
                font-family: PingFang-SC-Medium;
                font-size: 12px;
            }
        }

        .popup-body {
            padding: 12px 18px;

            .popup-scroll {
                max-height: 260px;
                overflow-y: scroll;

                .group-popup-detail {
                    height: 52px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;

                    .group-popup-detail-left {
                        display: flex;

                        .detail-img {
                            width: 40px;
                            height: 40px;
                            border-radius: 50%;
                        }

                        .detail-desc {
                            margin-left: 9px;
                            display: flex;
                            flex-direction: column;
                            justify-content: space-around;

                            .desc-text {
                                font-family: PingFang-SC-Medium;
                                font-size: 13px;
                                color: #383838;
                                line-height: 14px;

                                .text-num {
                                    color: #FF6436;
                                }
                            }

                            .desc-countdown {
                                font-family: PingFang-SC-Regular;
                                font-size: 12px;
                                color: #777893;
                                line-height: 14px;
                            }
                        }
                    }

                    .group-popup-detail-right {
                        height: 24px;
                        width: 62px;
                        border: 0.5px solid #FF6436;
                        border-radius: 15px;
                        font-family: PingFang-SC-Medium;
                        font-size: 13px;
                        color: #FF6436;
                        text-align: center;
                        line-height: 24px;
                    }
                }
            }
        }

        .popup-close {
            height: 28px;
            width: 28px;
            position: absolute;
            bottom: -52px;
            left: 50%;
            transform: translate(-50%, 0);

            .close-img {
                height: 28px;
                width: 28px;
            }
        }
    }

    .mask {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 20;
        background: rgba(0, 0, 0, 0.4);
    }

</style>



// WEBPACK FOOTER //
// groupListPopup.vue